import _slicedToArray from "/home/kms-config/ikos-kms-v2/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import React, { forwardRef, useState, useRef, useEffect } from 'react';
import { clamp, assignRef, useMergedRef, useOs } from '@mantine/hooks';
import { useComponentDefaultProps } from '@mantine/styles';
import { getInputMode } from './get-input-mode/get-input-mode.js';
import { Chevron } from './Chevron.js';
import useStyles, { CONTROL_SIZES } from './NumberInput.styles.js';
import { TextInput } from '../TextInput/TextInput.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var defaultFormatter = function defaultFormatter(value) {
  return value || "";
};
var defaultParser = function defaultParser(num) {
  if (num === "-") {
    return num;
  }
  var tempNum = num;
  if (tempNum[0] === ".") {
    tempNum = "0".concat(num);
  }
  var parsedNum = parseFloat(tempNum);
  if (Number.isNaN(parsedNum)) {
    return void 0;
  }
  return num;
};
var CHEVRON_SIZES = {
  xs: 10,
  sm: 14,
  md: 16,
  lg: 18,
  xl: 20
};
var defaultProps = {
  step: 1,
  hideControls: false,
  size: "sm",
  precision: 0,
  noClampOnBlur: false,
  removeTrailingZeros: false,
  formatter: defaultFormatter,
  parser: defaultParser,
  type: "text"
};
var NumberInput = forwardRef(function (props, ref) {
  var _a = useComponentDefaultProps("NumberInput", defaultProps, props),
    readOnly = _a.readOnly,
    disabled = _a.disabled,
    value = _a.value,
    onChange = _a.onChange,
    decimalSeparator = _a.decimalSeparator,
    min = _a.min,
    max = _a.max,
    startValue = _a.startValue,
    step = _a.step,
    stepHoldInterval = _a.stepHoldInterval,
    stepHoldDelay = _a.stepHoldDelay,
    onBlur = _a.onBlur,
    onFocus = _a.onFocus,
    onKeyDown = _a.onKeyDown,
    onKeyUp = _a.onKeyUp,
    hideControls = _a.hideControls,
    radius = _a.radius,
    variant = _a.variant,
    precision = _a.precision,
    removeTrailingZeros = _a.removeTrailingZeros,
    defaultValue = _a.defaultValue,
    noClampOnBlur = _a.noClampOnBlur,
    handlersRef = _a.handlersRef,
    classNames = _a.classNames,
    styles = _a.styles,
    size = _a.size,
    rightSection = _a.rightSection,
    rightSectionWidth = _a.rightSectionWidth,
    formatter = _a.formatter,
    parser = _a.parser,
    inputMode = _a.inputMode,
    unstyled = _a.unstyled,
    type = _a.type,
    others = __objRest(_a, ["readOnly", "disabled", "value", "onChange", "decimalSeparator", "min", "max", "startValue", "step", "stepHoldInterval", "stepHoldDelay", "onBlur", "onFocus", "onKeyDown", "onKeyUp", "hideControls", "radius", "variant", "precision", "removeTrailingZeros", "defaultValue", "noClampOnBlur", "handlersRef", "classNames", "styles", "size", "rightSection", "rightSectionWidth", "formatter", "parser", "inputMode", "unstyled", "type"]);
  var _useStyles = useStyles({
      radius: radius,
      size: size
    }, {
      classNames: classNames,
      styles: styles,
      unstyled: unstyled,
      name: "NumberInput"
    }),
    classes = _useStyles.classes,
    cx = _useStyles.cx,
    theme = _useStyles.theme;
  var parsePrecision = function parsePrecision(val) {
    if (val === void 0) return void 0;
    var result = val.toFixed(precision);
    if (removeTrailingZeros && precision > 0) {
      result = result.replace(new RegExp("[0]{0,".concat(precision, "}$")), "");
      if (result.endsWith(".") || result.endsWith(decimalSeparator)) {
        result = result.slice(0, -1);
      }
    }
    return result;
  };
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focused = _useState2[0],
    setFocused = _useState2[1];
  var _useState3 = useState(typeof value === "number" ? value : typeof defaultValue === "number" ? defaultValue : void 0),
    _useState4 = _slicedToArray(_useState3, 2),
    _value = _useState4[0],
    setValue = _useState4[1];
  var finalValue = typeof value === "number" ? value : _value;
  var _useState5 = useState(typeof finalValue === "number" ? parsePrecision(finalValue) : ""),
    _useState6 = _slicedToArray(_useState5, 2),
    tempValue = _useState6[0],
    setTempValue = _useState6[1];
  var inputRef = useRef();
  var handleValueChange = function handleValueChange(val) {
    if (val !== _value && !Number.isNaN(val)) {
      typeof onChange === "function" && onChange(val);
      setValue(val);
    }
  };
  var formatNum = function formatNum() {
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var parsedStr = typeof val === "number" ? String(val) : val;
    if (decimalSeparator) {
      parsedStr = parsedStr.replace(/\./g, decimalSeparator);
    }
    return formatter(parsedStr);
  };
  var parseNum = function parseNum(val) {
    var num = val;
    if (decimalSeparator) {
      num = num.replace(new RegExp("\\".concat(decimalSeparator), "g"), ".");
    }
    return parser(num);
  };
  var _min = typeof min === "number" ? min : -Infinity;
  var _max = typeof max === "number" ? max : Infinity;
  var incrementRef = useRef();
  incrementRef.current = function () {
    var _a2, _b, _c;
    if (_value === void 0) {
      handleValueChange((_a2 = startValue != null ? startValue : min) != null ? _a2 : 0);
      setTempValue((_c = (_b = parsePrecision(startValue)) != null ? _b : parsePrecision(min)) != null ? _c : "0");
    } else {
      var result = parsePrecision(clamp(_value + step, _min, _max));
      handleValueChange(parseFloat(result));
      setTempValue(result);
    }
  };
  var decrementRef = useRef();
  decrementRef.current = function () {
    var _a2, _b, _c;
    if (_value === void 0) {
      handleValueChange((_a2 = startValue != null ? startValue : min) != null ? _a2 : 0);
      setTempValue((_c = (_b = parsePrecision(startValue)) != null ? _b : parsePrecision(min)) != null ? _c : "0");
    } else {
      var result = parsePrecision(clamp(_value - step, _min, _max));
      handleValueChange(parseFloat(result));
      setTempValue(result);
    }
  };
  assignRef(handlersRef, {
    increment: incrementRef.current,
    decrement: decrementRef.current
  });
  useEffect(function () {
    if (typeof value === "number" && !focused) {
      setValue(value);
      setTempValue(parsePrecision(value));
    }
    if (defaultValue === void 0 && value === void 0 && !focused) {
      setValue(value);
      setTempValue("");
    }
  }, [value, precision]);
  var shouldUseStepInterval = stepHoldDelay !== void 0 && stepHoldInterval !== void 0;
  var onStepTimeoutRef = useRef(null);
  var stepCountRef = useRef(0);
  var onStepDone = function onStepDone() {
    if (onStepTimeoutRef.current) {
      window.clearTimeout(onStepTimeoutRef.current);
    }
    onStepTimeoutRef.current = null;
    stepCountRef.current = 0;
  };
  var onStepHandleChange = function onStepHandleChange(isIncrement) {
    if (isIncrement) {
      incrementRef.current();
    } else {
      decrementRef.current();
    }
    stepCountRef.current += 1;
  };
  var onStepLoop = function onStepLoop(isIncrement) {
    onStepHandleChange(isIncrement);
    if (shouldUseStepInterval) {
      var interval = typeof stepHoldInterval === "number" ? stepHoldInterval : stepHoldInterval(stepCountRef.current);
      onStepTimeoutRef.current = window.setTimeout(function () {
        return onStepLoop(isIncrement);
      }, interval);
    }
  };
  var onStep = function onStep(event, isIncrement) {
    event.preventDefault();
    inputRef.current.focus();
    onStepHandleChange(isIncrement);
    if (shouldUseStepInterval) {
      onStepTimeoutRef.current = window.setTimeout(function () {
        return onStepLoop(isIncrement);
      }, stepHoldDelay);
    }
  };
  useEffect(function () {
    onStepDone();
    return onStepDone;
  }, []);
  var controls = /* @__PURE__ */React.createElement("div", {
    className: classes.rightSection
  }, /* @__PURE__ */React.createElement("button", {
    type: "button",
    tabIndex: -1,
    "aria-hidden": true,
    disabled: finalValue >= max,
    className: cx(classes.control, classes.controlUp),
    onPointerDown: function onPointerDown(event) {
      onStep(event, true);
    },
    onPointerUp: onStepDone,
    onPointerLeave: onStepDone
  }, /* @__PURE__ */React.createElement(Chevron, {
    size: theme.fn.size({
      size: size,
      sizes: CHEVRON_SIZES
    }),
    direction: "up"
  })), /* @__PURE__ */React.createElement("button", {
    type: "button",
    tabIndex: -1,
    "aria-hidden": true,
    disabled: finalValue <= min,
    className: cx(classes.control, classes.controlDown),
    onPointerDown: function onPointerDown(event) {
      onStep(event, false);
    },
    onPointerUp: onStepDone,
    onPointerLeave: onStepDone
  }, /* @__PURE__ */React.createElement(Chevron, {
    size: theme.fn.size({
      size: size,
      sizes: CHEVRON_SIZES
    }),
    direction: "down"
  })));
  var handleChange = function handleChange(event) {
    var evt = event.nativeEvent;
    if (evt.isComposing) {
      return;
    }
    var val = event.target.value;
    var parsed = parseNum(val);
    setTempValue(parsed);
    if (val === "" || val === "-") {
      handleValueChange(void 0);
    } else {
      val.trim() !== "" && !Number.isNaN(parsed) && handleValueChange(parseFloat(parsed));
    }
  };
  var handleBlur = function handleBlur(event) {
    var _a2;
    if (event.target.value === "") {
      setTempValue("");
      handleValueChange(void 0);
    } else {
      var newNumber = event.target.value;
      if (newNumber[0] === "".concat(decimalSeparator) || newNumber[0] === ".") {
        newNumber = "0".concat(newNumber);
      }
      var parsedVal = parseNum(newNumber);
      var val = clamp(parseFloat(parsedVal), _min, _max);
      if (!Number.isNaN(val)) {
        if (!noClampOnBlur) {
          setTempValue(parsePrecision(val));
          handleValueChange(parseFloat(parsePrecision(val)));
        }
      } else {
        setTempValue((_a2 = parsePrecision(finalValue)) != null ? _a2 : "");
      }
    }
    setFocused(false);
    typeof onBlur === "function" && onBlur(event);
  };
  var handleFocus = function handleFocus(event) {
    setFocused(true);
    typeof onFocus === "function" && onFocus(event);
  };
  var handleKeyDown = function handleKeyDown(event) {
    typeof onKeyDown === "function" && onKeyDown(event);
    if (event.repeat && shouldUseStepInterval && (event.key === "ArrowUp" || event.key === "ArrowDown")) {
      event.preventDefault();
      return;
    }
    if (!readOnly) {
      if (event.key === "ArrowUp") {
        onStep(event, true);
      } else if (event.key === "ArrowDown") {
        onStep(event, false);
      }
    }
  };
  var handleKeyUp = function handleKeyUp(event) {
    typeof onKeyUp === "function" && onKeyUp(event);
    if (event.key === "ArrowUp" || event.key === "ArrowDown") {
      onStepDone();
    }
  };
  return /* @__PURE__ */React.createElement(TextInput, __spreadProps(__spreadValues({}, others), {
    type: type,
    variant: variant,
    value: formatNum(tempValue),
    disabled: disabled,
    readOnly: readOnly,
    ref: useMergedRef(inputRef, ref),
    onChange: handleChange,
    onBlur: handleBlur,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    rightSection: rightSection || (disabled || readOnly || hideControls || variant === "unstyled" ? null : controls),
    rightSectionWidth: rightSectionWidth || theme.fn.size({
      size: size,
      sizes: CONTROL_SIZES
    }) + 1,
    radius: radius,
    max: max,
    min: min,
    step: step,
    size: size,
    styles: styles,
    classNames: classNames,
    inputMode: inputMode || getInputMode(step, precision, useOs()),
    __staticSelector: "NumberInput",
    unstyled: unstyled
  }));
});
NumberInput.displayName = "@mantine/core/NumberInput";
export { NumberInput };